export class Controller {

    /** @ngInject */
    constructor(UserSettingsService) {
        this.UserSettingsService = UserSettingsService;
    }

    $onInit() {
        this.setDisplayNaming=this.resolve.setDisplayNaming;
    }


    process() {
        this.isSaving = true;
        this.UserSettingsService
            .applyDisplayNameChanges(this.resolve.companyId,this.resolve.setDisplayNaming)
            .then(() => this.close())
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/all-users/user-settings/confirm/user-settings-confirm.controller.js